import NarrationWaveform from "./NarrationWaveform";

export default function NarrationButton({
  title,
  audioUrl,
  playing,
  loading,
  disabled,
  onClick,
}) {
  if (!audioUrl) return null;
  const label = loading
    ? "Loading narration"
    : playing ? "Pause narration" : "Listen to description";

  return (
    <button
      type="button"
      className="narration-button"
      disabled={loading || disabled}
      onClick={onClick}
      aria-label={`${label}: ${title}`}
      aria-pressed={Boolean(playing)}
      title={label}
    >
      <NarrationWaveform animated={playing && !loading && !disabled} />
    </button>
  );
}
